"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const react_redux_1 = require("react-redux");
const next13_utils_common_get_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.get-cookie"));
const next13_utils_common_set_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.set-cookie"));
const next13_reducers_main_reducer_1 = require("@gerenciatd/next13.reducers.main-reducer");
const next13_utils_metrics_send_ga_page_event_1 = __importDefault(require("@gerenciatd/next13.utils.metrics.send-ga-page-event"));
const utils_1 = require("./utils");
const EVENT_TYPES = {
    VIEW: 'view',
    LOADED: 'printed',
};
class RouteHandler extends react_1.Component {
    constructor() {
        super(...arguments);
        this.getContextSeoInfo = () => {
            let contextSeoMeta = '';
            let pageName = '';
            let pageProductName = '';
            try {
                contextSeoMeta = document.querySelector('meta[id="context_seo_meta"]').getAttribute('content');
            }
            catch (error) {
                console.log(error);
            }
            try {
                pageName = document.querySelector('meta[id="page_name"]').getAttribute('content');
            }
            catch (error) {
                console.log(error);
            }
            try {
                pageProductName = document.querySelector('meta[id="product_name"]').getAttribute('content');
            }
            catch (error) {
                console.log(error);
            }
            const res = {
                contextSeoMeta,
                pageName,
                pageProductName,
            };
            return res;
        };
        this.getReadyGA = () => {
            let ga = (0, next13_utils_common_get_cookie_1.default)('_ga') || '';
            const gaTokkens = ga.split('.');
            if (gaTokkens.length > 2) {
                ga = gaTokkens.slice(2).join('.');
            }
            return ga;
        };
        this.getSessId = () => {
            let sessId = (0, next13_utils_common_get_cookie_1.default)('_mc_sessid');
            if (!sessId) {
                sessId = `${new Date().getTime()}`;
                (0, next13_utils_common_set_cookie_1.default)('_mc_sessid', sessId, undefined, '.movistar.es');
            }
            return sessId;
        };
        this.sendPageEvent = (context, eventType) => {
            try {
                const data = (0, utils_1.createPageEventObject)(context);
                // Event view, buen punto para el set general de ga
                if (eventType === EVENT_TYPES.VIEW) {
                    // inicializo config
                    const mainProperties = (0, utils_1.extractMainProperties)(data);
                    const userProperties = (0, utils_1.extractUserProperties)(data);
                    let optanon = (0, next13_utils_common_get_cookie_1.default)('OptanonConsent');
                    optanon = decodeURIComponent(optanon);
                    const ad_storage = optanon.indexOf('C0004:1') !== -1 ? 'granted' : 'denied';
                    const analytics_storage = optanon.indexOf('C0002:1') !== -1 ? 'granted' : 'denied';
                    let zipcode = this.geo && this.geo.zone ? this.geo.zone : '';
                    if (zipcode === 'ZR') {
                        zipcode = 'regulada';
                    }
                    if (zipcode === 'ZL') {
                        zipcode = 'libre';
                    }
                    if (zipcode === 'ZM') {
                        zipcode = 'mixta';
                    }
                    const logado = (context && (context.userIdPartyHash || context.userCUCFijoHash || context.userCUCMovilHash || context.userCUCPrepagoHash)) || "";
                    if (ad_storage !== 'denied' || analytics_storage !== 'denied') {
                        gtag('consent', 'update', {
                            'ad_storage': ad_storage,
                            'analytics_storage': analytics_storage,
                        });
                    }
                    gtag('config', `${process.env.NEXT_PUBLIC_GTM_ID}`, Object.assign(Object.assign(Object.assign({ 'page_variation': logado ? 'cliente' : 'no-cliente', transport_url: 'https://landings.dev.col.movistar.es', first_party_collection: true }, mainProperties), userProperties), { 'zip-code': zipcode }));
                }
                else {
                    (0, next13_utils_metrics_send_ga_page_event_1.default)(eventType);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        this.handleRouteLanding = (...args) => {
            const context = this.createInitialContextObj();
            this.sendPageEvent(context, EVENT_TYPES.VIEW);
            this.sendPageEvent(context, EVENT_TYPES.LOADED);
            if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== 'dev') {
                Promise.resolve().then(() => __importStar(require('./ping-cms-page'))).then(pingModule => {
                    // ping a cms page
                    pingModule = pingModule.default;
                    let ping = new pingModule({ context });
                    ping.sendPingCmsPage();
                });
            }
        };
        this.createInitialContextObj = () => {
            const { context: ssrContext, checkCPAndSetZones, setCpParams, setContextData, setUserPqInfo } = this.props;
            let initialContextData = {};
            let geo = null;
            let userPq = null;
            const persistedInfo = Object.assign({}, (0, utils_1.getUserPersistedInfo)());
            let userContextInfo = {};
            if (persistedInfo) {
                // si hay persisted info me lo quedo
                userContextInfo = Object.assign({}, persistedInfo);
                // no tengo info de geo
                if (!userContextInfo.geo && userContextInfo && (!userContextInfo.geo || !userContextInfo.geo.postalCode)) {
                    checkCPAndSetZones({ cp: '' });
                }
                else {
                    // si tiene geo persistido me lo quedo
                    geo = {
                        cp: (userContextInfo.geo && userContextInfo.geo.postalCode) || '28030',
                        zone: (userContextInfo.geo && userContextInfo.geo.zone) || 'ZL',
                        municipio: (userContextInfo.geo && userContextInfo.geo.municipio) || '',
                        businessZones: (userContextInfo.geo && userContextInfo.geo.businessZones) || [],
                    };
                }
            }
            else {
                checkCPAndSetZones({ cp: '' });
                userContextInfo = {
                    userCUCFijoHash: "",
                    userCUCMovilHash: "",
                    userCUCPrepagoHash: "",
                    userIdPartyHash: "",
                    userName: "",
                    userType: "",
                };
            }
            try {
                (0, utils_1.setSegmentCookie)(`${process.env.NEXT_PUBLIC_ENV_SEGMENT}`);
                const pageId = (0, utils_1.generatePageId)();
                window.pageId = pageId;
                initialContextData = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ssrContext), { numLocationChanges: 0, tabId: (0, utils_1.getTabId)(), pageWebCode: null, pageName: null, pageWebName: null, pageProductCode: null, pageProductName: null, clientIDs: {
                        pageId,
                        ga: this.getReadyGA(),
                        sessId: this.getSessId(),
                    }, userType: '', pageSegment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`, contextURL: window.location.href, subseg: false, userPriority: false, version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || 'unknown' }), this.getContextSeoInfo()), persistedInfo), userContextInfo);
                // se lo mando a redux
                if (geo) {
                    setCpParams(geo);
                }
                if (initialContextData.userPq) {
                    userPq = initialContextData.userPq;
                    const userFlags = initialContextData.userFlags || [];
                    setUserPqInfo({
                        userPq,
                        userFlags,
                    });
                }
                else {
                    setUserPqInfo({
                        userPq: {},
                        userFlags: [],
                    });
                }
                // elimino de context
                if (initialContextData && initialContextData.geo) {
                    this.geo = initialContextData.geo;
                    delete initialContextData.geo;
                }
                if (initialContextData && initialContextData.userPq) {
                    // ante de eliminar lo dejo da nivel de clase para algún dia en pagina
                    this.userPq = initialContextData.userPq;
                    delete initialContextData.userPq;
                    delete initialContextData.userFlags;
                }
                setContextData(initialContextData);
                return initialContextData;
            }
            catch (error) {
                console.error(error);
                return initialContextData;
            }
        };
    }
    componentDidMount() {
        let { router } = this.props;
        this.handleRouteLanding();
        router.events.on('routeChangeComplete', this.handleRouteLanding);
    }
    render() {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
const mapStateToProps = (state) => ({
    context: state.main.context,
});
const mapDispatchToProps = (dispatch) => ({
    setCpParams: data => dispatch(next13_reducers_main_reducer_1.actions.setCpParams(data)),
    setContextData: newData => dispatch(next13_reducers_main_reducer_1.actions.setContextData(newData)),
    checkCPAndSetZones: (data) => dispatch(next13_reducers_main_reducer_1.actions.checkCPAndSetZones(data)),
    setUserPqInfo: (data) => dispatch(next13_reducers_main_reducer_1.actions.setUserPqInfo(data)),
});
exports.default = (0, router_1.withRouter)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(RouteHandler));
//# sourceMappingURL=index.js.map